import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ReactPlaceholder from 'react-placeholder'
import VisibilityIcon from '@material-ui/icons/Visibility'
import CommentIcon from '@material-ui/icons/Comment'
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined'
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import relativeTime from 'dayjs/plugin/relativeTime'
import DeleteButton from './DeleteButton'

dayjs.locale('pt-br')
dayjs.extend(relativeTime)


const useStyles = makeStyles(() => {
  return {
    root: {
      display: 'flex',
      paddingTop: 21,
      paddingBottom: 21,
      marginLeft: '-.5em',
      marginRight: '-.5em',
      '@media only screen and (max-width: 1050px)': {
        flexDirection: 'column'
      }
    },
    title: {
      color: '#000',
      fontSize: 21,
      fontWeight: 'bold'
    },
    category: {
      color: '#BA0D59',
      fontWeight: 500
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      margin: '0 .5em'
    },
    userName: {
      marginLeft: '.3em'
    },
    wrapperLabels: {
      flex: 1,
      justifyContent: 'flex-end',
      display: 'flex',
      '@media only screen and (max-width: 1050px)': {
        justifyContent: 'space-between'
      }
    },
    icon: { 
      fontSize: 18,
      marginRight: '.2em'
    },
    onlyDesktop: {
      '@media only screen and (max-width: 1050px)': {
        display: 'none'
      }
    }
  }
})

const TopicCardInfos = ({ loading, visualizacoes, createdAt, postadoPor, topico_id, deleteButton, resposta_id, quantidadeRespostas }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {(!!loading || !!postadoPor) && (
        <div className={classes.label}>
          <ReactPlaceholder style={{ width: 20, height: 20, marginRight: 5 }} type="round" showLoadingAnimation ready={!loading}>
            <AssignmentIndOutlinedIcon className={classes.icon} />
          </ReactPlaceholder>{' '}
          <Typography>
            <ReactPlaceholder style={{ width: 140 }} showLoadingAnimation ready={!loading}>
              <span className={classes.onlyDesktop}>Postado por:</span> <strong className={classes.userName}>{postadoPor}</strong>
            </ReactPlaceholder>
          </Typography>
        </div>
      )}
      <div className={classes.wrapperLabels}>
        {(!!loading || !!(visualizacoes ||  visualizacoes === 0)) && (
          <div className={classes.label}>
            <ReactPlaceholder style={{ width: 20, height: 20, marginRight: 5 }} type="round" showLoadingAnimation ready={!loading}>
              <VisibilityIcon className={classes.icon} />
            </ReactPlaceholder>{' '}
            <Typography>
              <ReactPlaceholder style={{ width: 140 }} showLoadingAnimation ready={!loading}>
                <span className={classes.onlyDesktop}>Visualizações:</span> <strong className={classes.userName}>{visualizacoes}</strong>
              </ReactPlaceholder>
            </Typography>
          </div>
        )}
        {(!!loading || !!(quantidadeRespostas === 0 || !!quantidadeRespostas)) && (
          <div className={classes.label}>
            <ReactPlaceholder style={{ width: 20, height: 20, marginRight: 5 }} type="round" showLoadingAnimation ready={!loading}>
              <CommentIcon className={classes.icon} />
            </ReactPlaceholder>{' '}
            <Typography>
              <ReactPlaceholder style={{ width: 140 }} showLoadingAnimation ready={!loading}>
                <span className={classes.onlyDesktop}>Respostas:</span> <strong>{quantidadeRespostas}</strong>
              </ReactPlaceholder>
            </Typography>
          </div>
        )}
        {(!!loading || !!createdAt) && (
          <div className={classes.label}>
            <ReactPlaceholder style={{ width: 20, height: 20, marginRight: 5 }} type="round" showLoadingAnimation ready={!loading}>
              <AccessTimeOutlinedIcon className={classes.icon} />
            </ReactPlaceholder>{' '}
            <Typography>
              <ReactPlaceholder style={{ width: 140 }} showLoadingAnimation ready={!loading}>
                {dayjs(dayjs(Number(createdAt))).from()}
              </ReactPlaceholder>
            </Typography>
          </div>
        )}
        <div className={classes.label}>
          {deleteButton && ( <DeleteButton topico_id={topico_id} resposta_id={resposta_id} />)}
        </div>
      </div>
    </div>
  )
}
export default TopicCardInfos
